app.addFeature(
    'loggingService',
    function() {
        'use strict';

        var self = this;

        self.init = function() {
        };

        self.setSessionData = function(data) {
            try {
                sessionStorage.setItem('sessionLog', JSON.stringify(data));
            }
            catch(exception) {
                console.error(`Error -- ${exception}`);

                //We're going to try to save what we have for logging
                self.saveLogToDatabase();
            }
        };

        self.getSessionData = function() {
            const logSessionStorage = sessionStorage.getItem('sessionLog');
            const parseAttempt = JSON.tryParse(logSessionStorage);

            if(!parseAttempt || parseAttempt.JSON_PARSE_ERROR) {
                return [];
            }

            return parseAttempt;
        };

        self.queueEntry = function(entry) {
            let logDataItems = self.getSessionData();
            logDataItems.push(entry);
            self.setSessionData(logDataItems);
        };

        self.saveLogEntry = function(action, source, data) {
            self.queueEntry({ action, source, data })
        };

        self.saveLogToDatabase = function(entryType = 'userLogEntry', collection = 'LOG_userSession') {
            let logDataItems = self.getSessionData();

            const sessionData = {
                cartID: app.dataStore.get('cartID'),
                accountID: app.dataStore.get('session.accountID'),
                token: app.dataStore.get('session.token')
            };

            app.ajax.request(
                {
                    url : '/',
                    contentType: "application/json",
                    responseType : "json",
                    args : {
                        data : {
                            jurisdiction : app.jurisdiction.get('name'),
                            entryType: entryType,
                            collection: collection,
                            account: app.dataStore.get('session.info'),
                            session: sessionData,
                            browserInfo: {
                                userAgent: navigator.userAgent,
                                language: navigator.language,
                                cookieEnabled: navigator.cookieEnabled,
                                userAgentData: navigator.userAgentData ?? '',
                                isMobile: (navigator.maxTouchPoints > 0) ? true : false
                            },
                            entryData : logDataItems
                        },
                        token : app.dataStore.get('session.token'),
                        task : 'logData'
                    }
                }
            );
        };

        return self;
    }
);